import React from 'react';
import { Card } from '@/components/ui/card';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const MetricCard = ({ title, value, subtitle, trend, icon: Icon, testId }) => {
  const getTrendIcon = () => {
    if (trend > 0) return <TrendingUp className="w-4 h-4 text-green-600" />;
    if (trend < 0) return <TrendingDown className="w-4 h-4 text-red-600" />;
    return <Minus className="w-4 h-4 text-gray-400" />;
  };

  return (
    <Card className="p-6 hover:border-gray-300 transition-colors duration-200" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="font-subheading text-sm font-medium uppercase tracking-wide text-muted-foreground">
            {title}
          </p>
          <p className="font-heading text-3xl md:text-4xl font-bold tabular-nums mt-2 text-gray-800">
            {value}
          </p>
          {subtitle && (
            <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
          {trend !== undefined && trend !== null && (
            <div className="flex items-center gap-1 mt-2">
              {getTrendIcon()}
              <span className={`text-sm font-medium ${
                trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-600'
              }`}>
                {trend > 0 && '+'}{trend}%
              </span>
            </div>
          )}
        </div>
        {Icon && (
          <div className="w-12 h-12 rounded-lg bg-[#FFE8EA] flex items-center justify-center">
            <Icon className="w-6 h-6 text-primary" />
          </div>
        )}
      </div>
    </Card>
  );
};